import * as THREE from 'three'
import pako from 'pako'

import { PLYLoader } from 'three/examples/jsm/loaders/PLYLoader'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

let camera,
  scene,
  renderer,
  controls,
  i = 0,
  cache = {},
  cachedIndex = 0,
  door

const doorCount = 5
const doorStart = 2299
const totalCount = doorCount

const doorPosition = [0, 0, 4]
const doorRotation = [0, THREE.MathUtils.degToRad(180), 0]
const cameraPosition = [0, 1, 0]

const fpsInterval = 100
let then = Date.now()

const plyLoader = new PLYLoader()

const doorMaterial = new THREE.PointsMaterial({
  size: 5,
  sizeAttenuation: false,
  transparent: true,
  map: new THREE.TextureLoader().load('disc.png'),
  vertexColors: false,
  color: 0xffffff,
  depthWrite: false,
  depthTest: true,
  opacity: 0.15
})

const rendererElement = document.getElementById('door')!
const preloader = document.createElement('div')

preloader.id = 'preloader'
preloader.innerHTML = 'Loading...'

document.getElementById('container')!.appendChild(preloader)

preload()

function cacheGeometry(file: string) {
  fetch(file).then(async compressed => {
    let geometry

    const response = await compressed.arrayBuffer()

    let inflated

    try {
      inflated = pako.inflate(response, { to: 'string' })
    } catch (error) {
      inflated = pako.inflate(response, { to: 'string', raw: true })
    }

    geometry = plyLoader.parse(inflated)

    geometry.scale(2, 2, 2)

    cache[file] = geometry
    cachedIndex++

    preloader.innerHTML = `Loading (${cachedIndex}/${totalCount})...`

    if (cachedIndex === totalCount) {
      preloader.className = 'fadeOut'
      init()
      animate()
    }
  })
}

function preload() {
  while (i++ < doorCount) {
    cacheGeometry(`ply/000${doorStart + i}.ply.gz`)
  }
}

function handleDoorGeometry(geometry, file) {
  scene.remove(door)

  try {
    geometry.center()
    geometry.computeVertexNormals()
    door = new THREE.Points(geometry, doorMaterial)

    door.position.set(...doorPosition)
    door.rotation.set(...doorRotation)

    scene.add(door)
  } catch (error) {
    cache[file] = undefined
  }
}

function update() {
  const num = doorStart + Math.round(Math.random() * doorCount)
  const file = `ply/000${num}.ply.gz`

  if (cache[file]) {
    handleDoorGeometry(cache[file], file)
  }
}

function init() {
  camera = new THREE.PerspectiveCamera(
    70,
    window.innerWidth / window.innerHeight,
    0.1,
    100
  )
  camera.position.set(...cameraPosition)
  camera.updateProjectionMatrix()

  scene = new THREE.Scene()
  scene.add(camera)

  const fog = new THREE.FogExp2(0x62526a, 0.01)
  scene.fog = fog
  scene.background = null

  const ambient = new THREE.HemisphereLight(0xffffff, 0x62526a, 0.5)
  scene.add(ambient)

  renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
  renderer.setPixelRatio(window.devicePixelRatio)
  renderer.setSize(
    rendererElement.clientWidth,
    rendererElement.clientHeight + 380
  )

  controls = new OrbitControls(camera, renderer.domElement)
  controls.target.set(-0.5, -1.2594503218755557, 4.487706934406722)
  controls.object.position.set(
    -3.706533678438677,
    0.13973488829984304,
    -0.6896190192129747
  )
  controls.update()
  controls.enablePan = true
  controls.enableZoom = true
  controls.enableDamping = true

  rendererElement.appendChild(renderer.domElement)

  renderer.domElement.className = 'fadeIn'

  window.addEventListener('resize', onWindowResize)
}

function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight
  camera.updateProjectionMatrix()
  renderer.setSize(
    rendererElement.clientWidth,
    rendererElement.clientHeight + 380
  )
}

function animate() {
  requestAnimationFrame(animate)

  const now = Date.now()
  const elapsed = now - then

  if (elapsed > fpsInterval) {
    then = now - (elapsed % fpsInterval)
    update()
  }

  controls.update()
  renderer.render(scene, camera)
}

const calculateVideoSize = () => {
  const video = document.getElementById('player') as HTMLVideoElement
  const videoContainer = document.body

  if (!video) {
    return
  }

  const videoRatio = video.videoWidth / video.videoHeight
  const containerRatio =
    videoContainer.clientWidth / videoContainer.clientHeight

  if (videoRatio > containerRatio) {
    video.style.width = '100%'
    video.style.height = 'auto'
  } else {
    video.style.width = 'auto'
    video.style.height = '100%'
  }
}

// calculate video size on resize
window.addEventListener('resize', calculateVideoSize)
